import './App.css';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Home from './Components/Home';
import Navigation from './Components/Navigation';
import About from './Components/About';
import Projects from './Components/Projects';
import Resume from './Components/Resume';
import ScrollToTop from './Components/ScrollToTop'

function App() {
  return (
    <Router>
      <ScrollToTop/>
      <Navigation>
        <Routes>
          <Route path='/home' element={<Home />} />
          <Route path='/projects' element={<Projects />} />
          <Route path='/resume' element={<Resume />} />
          <Route path='/about' element={<About />} />
          <Route path='*' element={<Navigate to='/home' />} />
        </Routes>
      </Navigation>
    </Router>
  );
}

export default App;
